import mongoose from "mongoose";
import { match } from "@mssi/pssp-shared";

export interface Contact {
  _id: mongoose.Schema.Types.ObjectId;
  _text: string;
  contactId: string;
  itsmCustomerId: string;
  firstName: string;
  lastName: string;
  name: string;
  emailAddress: string;
  phoneNumber: string;
  phoneNumber2: string;
  bpid: string;
  employeeResponsibleNumber?: string;
  mailStop: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contactTypes: string[];
  langCountryId: string;
  contactNote: string;
  hpContactFg?: string;
  active: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  refreshId?: string;
}

export const ContactSchema = new mongoose.Schema({
  _text: String,
  contactId: { type: String, index: true },
  itsmCustomerId: { type: String, index: true },
  firstName: String,
  lastName: String,
  name: String, // concat first + last when saving
  emailAddress: String,
  phoneNumber: String,
  phoneNumber2: String,
  bpid: String,
  employeeResponsibleNumber: String,
  mailStop: String,
  contactTypes: [String],
  langCountryId: String,
  contactNote: String,
  hpContactFg: String,
  active: Boolean,
  refreshId: String,
}, { timestamps: true });

export const props: (keyof Contact)[] = [
  "_text",
  "contactId",
  "itsmCustomerId",
  "firstName",
  "lastName",
  "name",
  "emailAddress",
  "phoneNumber",
  "phoneNumber2",
  "bpid",
  "employeeResponsibleNumber",
  "mailStop",
  "contactTypes",
  "langCountryId",
  "contactNote",
  "hpContactFg",
  "active",
];

export const searchProps: (keyof Contact)[] = [
  "_text",
  "firstName",
  "lastName",
  "emailAddress",
];

export function matches(a: Contact, b: Contact) {
  return match(a, b, props);
}

export const contactUtils = {
  props,
  searchProps,
  matches,
};
